import React from "react"
import {PayPalButton} from "react-paypal-button-v2";

const sandboxID = 'ATL5SnmVsCVqtfCAJVUEbcxHxkNcaakhE5u2w_gdYxFfAtaHhGpW8jgWnrfHXU0QhbhqHzWEfih6-ybu'
const liveID = 'AaIf5HSG3qmaLuYZbdKhJOoWBaD22J2tyqD3OKA9_IwK_Z2g36WSTBhhEHcfNJg6-tfEoTdwEdDM7SLI';

const PayPal = (props) => (
    <PayPalButton
        amount={props.number}
        shippingPreference="NO_SHIPPING" // default is "GET_FROM_FILE"
        style={{layout: "horizontal"}}
        onSuccess={(details, data) => {
            console.log(details);
            console.log(data);
            props.onsuccess({ID: data.orderID, payer: details.payer.name.given_name + ' ' + details.payer.name.surname});
        }}
        catchError={(err) => {
            console.log(err);
        }}
        options={{
            clientId: liveID,
            currency: 'EUR',
        }}
    />
)

export default PayPal
